var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simple-form" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.devcDef, rules: _vm.rules }
        },
        [
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("基本信息")])
          ]),
          _vm._v(" "),
          _vm.devcDef.assetType != null
            ? _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("定义编码")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "innerCode",
                          rules: { validator: _vm.checkModel, trigger: "blur" }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "width-1-5x",
                          attrs: { type: "text" },
                          model: {
                            value: _vm.devcDef.innerCode,
                            callback: function($$v) {
                              _vm.$set(_vm.devcDef, "innerCode", $$v)
                            },
                            expression: "devcDef.innerCode"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("资产品牌")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "innerDevcBrandName" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: "", type: "text" },
                      model: {
                        value: _vm.devcDef.innerDevcBrandName,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "innerDevcBrandName", $$v)
                        },
                        expression: "devcDef.innerDevcBrandName"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                      attrs: { title: "选择" },
                      on: {
                        click: function($event) {
                          _vm.selectInnerBrandDlg()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("名称")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "name",
                      rules: { validator: _vm.checkNullModel, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { type: "text" },
                      on: { change: _vm.titleChange },
                      model: {
                        value: _vm.devcDef.name,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "name", $$v)
                        },
                        expression: "devcDef.name"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("型号")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "model",
                      rules: { validator: _vm.checkNullModel, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { type: "text" },
                      on: { change: _vm.titleChange },
                      model: {
                        value: _vm.devcDef.model,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "model", $$v)
                        },
                        expression: "devcDef.model"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("规格")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "fixedSpec",
                      rules: { validator: _vm.checkNullModel, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { type: "text" },
                      on: { change: _vm.titleChange },
                      model: {
                        value: _vm.devcDef.fixedSpec,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "fixedSpec", $$v)
                        },
                        expression: "devcDef.fixedSpec"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("单位")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "theUnit",
                      rules: { validator: _vm.checkModel, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { type: "text" },
                      model: {
                        value: _vm.devcDef.theUnit,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "theUnit", $$v)
                        },
                        expression: "devcDef.theUnit"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group top" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("图片")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("swb-file-upload", {
                  attrs: {
                    fileFor: "image-misc",
                    fileGroup: "image-misc",
                    onBeforeUpload: _vm.onBeforeUpload,
                    onProgress: _vm.onProgress,
                    onDone: _vm.onUploadDone,
                    multipleFile: false
                  }
                }),
                _vm._v(" "),
                _vm.imgFile != null
                  ? _c("div", { staticClass: "file-area clearfix" }, [
                      _vm.imgFile.fileBrowseUrl != null &&
                      _vm.imgFile.fileBrowseUrl != ""
                        ? _c(
                            "span",
                            [
                              _c("swb-file-item", {
                                attrs: {
                                  fileUuid: _vm.imgFile.fileUuid,
                                  fileBrowseUrl: _vm.imgFile.fileBrowseUrl,
                                  deletable: true,
                                  onDelete: _vm.removeUpload
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("资产描述全称")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "title",
                      rules: { validator: _vm.checkTitle, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { type: "text" },
                      model: {
                        value: _vm.devcDef.title,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "title", $$v)
                        },
                        expression: "devcDef.title"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("资产分类")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "innerDevcCatName" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: "", type: "text" },
                      model: {
                        value: _vm.devcDef.innerDevcCatName,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "innerDevcCatName", $$v)
                        },
                        expression: "devcDef.innerDevcCatName"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                      attrs: { title: "选择" },
                      on: {
                        click: function($event) {
                          _vm.selectInnerCatDlg()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("管理信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("使用方式")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "useManner" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择" },
                        model: {
                          value: _vm.devcDef.useManner,
                          callback: function($$v) {
                            _vm.$set(_vm.devcDef, "useManner", $$v)
                          },
                          expression: "devcDef.useManner"
                        }
                      },
                      _vm._l(_vm.devcUseMannerList, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.text, value: item.value }
                        })
                      })
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          !_vm.assetTypeDisabled
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("资产管理方式")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "assetType" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.assetTypeDisabled },
                            on: { change: _vm.selectAssetType },
                            model: {
                              value: _vm.devcDef.assetType,
                              callback: function($$v) {
                                _vm.$set(_vm.devcDef, "assetType", $$v)
                              },
                              expression: "devcDef.assetType"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("单品式")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("批量式")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("按金额管理")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "splitible" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.devcDef.splitible,
                          callback: function($$v) {
                            _vm.$set(_vm.devcDef, "splitible", $$v)
                          },
                          expression: "devcDef.splitible"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: true } }, [
                          _vm._v("是")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: false } }, [
                          _vm._v("否")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.normalFlag
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("定义完善程度")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "normalized" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.disableNormalized },
                            on: { change: _vm.normalizedChange },
                            model: {
                              value: _vm.devcDef.normalized,
                              callback: function($$v) {
                                _vm.$set(_vm.devcDef, "normalized", $$v)
                              },
                              expression: "devcDef.normalized"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("在账资产")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("账外设备")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.normalFlag && _vm.devcDef.normalized
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("资产属性")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-form-item", { attrs: { prop: "assetNature" } }, [
                      _vm.devcDef.assetNature != null &&
                      _vm.devcDef.assetNature != 0
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.assetNatureMap[_vm.devcDef.assetNature]
                              )
                            )
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.normalFlag && _vm.devcDef.normalized
            ? _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("财务类别")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "assetKindId" } },
                      [
                        _c("el-input", {
                          staticClass: "width-1-5x bottom-line",
                          attrs: { disabled: "", type: "text" },
                          model: {
                            value: _vm.devcDef.assetKindName,
                            callback: function($$v) {
                              _vm.$set(_vm.devcDef, "assetKindName", $$v)
                            },
                            expression: "devcDef.assetKindName"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                          attrs: { title: "选择" },
                          on: {
                            click: function($event) {
                              _vm.selectAssetKind()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("维保分组")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "devcGroupId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择", filterable: "" },
                        on: { change: _vm.changeDevcGroup },
                        model: {
                          value: _vm.devcDef.devcGroupId,
                          callback: function($$v) {
                            _vm.$set(_vm.devcDef, "devcGroupId", $$v)
                          },
                          expression: "devcDef.devcGroupId"
                        }
                      },
                      _vm._l(_vm.devcGroupList, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.fullName, value: item.id }
                        })
                      })
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.devcCustTag1.enabled
            ? _c("div", { staticClass: "form-group top" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v(_vm._s(_vm.devcCustTag1.dispName))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "memo" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            attrs: { placeholder: "请选择", clearable: "" },
                            model: {
                              value: _vm.devcDef.devcCustTag1,
                              callback: function($$v) {
                                _vm.$set(_vm.devcDef, "devcCustTag1", $$v)
                              },
                              expression: "devcDef.devcCustTag1"
                            }
                          },
                          _vm._l(_vm.devcCustTag1.itemList, function(item) {
                            return _c("el-option", {
                              attrs: {
                                label: item.disabled
                                  ? item.name + "(已禁用)"
                                  : item.name,
                                value: item.id,
                                disabled: item.disabled
                              }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcCustTag2.enabled
            ? _c("div", { staticClass: "form-group top" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v(_vm._s(_vm.devcCustTag2.dispName))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "memo" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            attrs: { placeholder: "请选择", clearable: "" },
                            model: {
                              value: _vm.devcDef.devcCustTag2,
                              callback: function($$v) {
                                _vm.$set(_vm.devcDef, "devcCustTag2", $$v)
                              },
                              expression: "devcDef.devcCustTag2"
                            }
                          },
                          _vm._l(_vm.devcCustTag2.itemList, function(item) {
                            return _c("el-option", {
                              attrs: {
                                label: item.disabled
                                  ? item.name + "(已禁用)"
                                  : item.name,
                                value: item.id,
                                disabled: item.disabled
                              }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcCustTag3.enabled
            ? _c("div", { staticClass: "form-group top" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v(_vm._s(_vm.devcCustTag3.dispName))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "memo" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            attrs: { placeholder: "请选择", clearable: "" },
                            model: {
                              value: _vm.devcDef.devcCustTag3,
                              callback: function($$v) {
                                _vm.$set(_vm.devcDef, "devcCustTag3", $$v)
                              },
                              expression: "devcDef.devcCustTag3"
                            }
                          },
                          _vm._l(_vm.devcCustTag3.itemList, function(item) {
                            return _c("el-option", {
                              attrs: {
                                label: item.disabled
                                  ? item.name + "(已禁用)"
                                  : item.name,
                                value: item.id,
                                disabled: item.disabled
                              }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("采购信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("仅用于临采")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "tempOnly" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { disabled: _vm.tempOnlyDisabled },
                        on: { change: _vm.changegTempOnly },
                        model: {
                          value: _vm.devcDef.tempOnly,
                          callback: function($$v) {
                            _vm.$set(_vm.devcDef, "tempOnly", $$v)
                          },
                          expression: "devcDef.tempOnly"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: true } }, [
                          _vm._v("是")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: false } }, [
                          _vm._v("否")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("用于采购")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "splitible" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { disabled: _vm.purchFlagDisabled },
                        on: { change: _vm.changePurchFlag },
                        model: {
                          value: _vm.devcDef.purchFlag,
                          callback: function($$v) {
                            _vm.$set(_vm.devcDef, "purchFlag", $$v)
                          },
                          expression: "devcDef.purchFlag"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: true } }, [
                          _vm._v("是")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: false } }, [
                          _vm._v("否")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.devcDef.purchFlag
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("必须集中采购")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "centBuyRequired" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.devcDef.centBuyRequired,
                              callback: function($$v) {
                                _vm.$set(_vm.devcDef, "centBuyRequired", $$v)
                              },
                              expression: "devcDef.centBuyRequired"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("是")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("否")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcDef.assetType == 0
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("需要安装")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "setupFlag" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.flagChange },
                            model: {
                              value: _vm.devcDef.setupFlag,
                              callback: function($$v) {
                                _vm.$set(_vm.devcDef, "setupFlag", $$v)
                              },
                              expression: "devcDef.setupFlag"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("是")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("否")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcDef.assetType == 0
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("需要供应商提供唯一标识码")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "vendorUknoFlag" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.vendorUknoFlagDisabled },
                            model: {
                              value: _vm.devcDef.vendorUknoFlag,
                              callback: function($$v) {
                                _vm.$set(_vm.devcDef, "vendorUknoFlag", $$v)
                              },
                              expression: "devcDef.vendorUknoFlag"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("是")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("否")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcDef.assetType != 2 && _vm.assetFifoInvolved
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("先进先出")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "stockFifo" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.devcDef.stockFifo,
                              callback: function($$v) {
                                _vm.$set(_vm.devcDef, "stockFifo", $$v)
                              },
                              expression: "devcDef.stockFifo"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("是")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("否")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("折旧与分摊规则")])
          ]),
          _vm._v(" "),
          _vm.devcDef.assetType != 2
            ? _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { class: _vm.normalizedFlag ? "required" : "" }, [
                    _vm._v("使用年限(月)")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "durableLife",
                          rules: {
                            validator: _vm.checkDurableLife,
                            trigger: "blur"
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "width-1-5x",
                          attrs: { type: "number" },
                          model: {
                            value: _vm.devcDef.durableLife,
                            callback: function($$v) {
                              _vm.$set(_vm.devcDef, "durableLife", $$v)
                            },
                            expression: "devcDef.durableLife"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcDef.assetType != 2 && _vm.normalFlag && _vm.devcDef.normalized
            ? _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("规则名称")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.devcDef.deprSpecName || ""))])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcDef.assetType != 2 && _vm.normalFlag && _vm.devcDef.normalized
            ? _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("规则编码")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.devcDef.deprSpecCode || ""))])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("附加信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group top" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("描述")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "memo",
                      rules: { validator: _vm.checkMemo, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "textarea", rows: 3, maxlength: 120 },
                      model: {
                        value: _vm.devcDef.memo,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "memo", $$v)
                        },
                        expression: "devcDef.memo"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("资料手册")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "swb-btn-link",
                on: {
                  click: function($event) {
                    _vm.selectManuals()
                  }
                }
              },
              [_vm._v("选择")]
            )
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.devcFiles, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { align: "left", prop: "fileName", label: "手册名称" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  width: "100",
                  prop: "innerOnly",
                  label: "使用范围"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.innerOnly
                          ? _c("span", [_vm._v("内部使用")])
                          : _c("span", [_vm._v("通用")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", width: "100", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.removeManuals(scope.row)
                              }
                            }
                          },
                          [_vm._v("移除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b77d570", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b77d570","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcDef/MerchtDevcDefSave.vue
// module id = 2397
// module chunks = 0